// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* [EXPERT_ANALYSIS]: Estilos para la nueva pantalla de Login minimalista */
.login-page-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5; /* Gris muy claro como en la imagen */
  margin: 0;
  padding: 0;
}

.login-card {
  width: 100%;
  max-width: 450px;
  padding: 2rem;
  text-align: center;
}

.login-card h2 {
  font-family: "Inter", "Segoe UI", Roboto, sans-serif;
  font-weight: 700;
  font-size: 2.2rem;
  color: #000;
  margin-bottom: 2rem;
}

.login-form-minimal {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  background-color: transparent !important; /* [EXPERT] Anula el blanco de App.css */
  box-shadow: none !important;
  max-width: none !important;
  padding: 0 !important;
}

/* Estilo para los inputs */
.login-input-minimal {
  width: 100% !important;
  padding: 0.8rem 1rem !important; /* [EXPERT] Altura reducida */
  border: 1px solid #ccc !important;
  border-radius: 10px !important;
  font-size: 1.1rem !important;
  transition: border-color 0.3s ease;
  background-color: #fff !important;
  margin-bottom: 0 !important; /* [EXPERT] Elimina margen de App.css que movía el icono */
}

.login-input-minimal:focus {
  border-color: #007bff !important;
  outline: none !important;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1) !important;
}

/* Contenedor del password */
.password-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
}

.toggle-password-minimal {
  position: absolute;
  right: 15px;
  cursor: pointer;
  color: #666;
  font-size: 1.1rem;
  z-index: 10;
  /* El icono se centra automáticamente gracias al wrapper flex */
}

/* Botón de Login (Estilo cuadrado azul) */
.btn-login-minimal {
  background-color: #007bff !important;
  border: none !important;
  border-radius: 12px !important;
  width: 75px !important;
  height: 75px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin: 2rem auto 0 !important;
  cursor: pointer;
  transition:
    transform 0.2s ease,
    background-color 0.2s ease;
}

.btn-login-minimal:hover {
  background-color: #0056b3 !important;
  transform: scale(1.05);
}

.btn-login-minimal:active {
  transform: scale(0.95);
}

.btn-login-minimal i {
  font-size: 2.5rem !important;
  color: #fff !important;
}

/* Estilos de PrimeReact Overrides si es necesario */
.p-toast {
  font-family: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB,EAAE,qCAAqC;EAChE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,wCAAwC,EAAE,wCAAwC;EAClF,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,sBAAsB;EACtB,+BAA+B,EAAE,6BAA6B;EAC9D,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,kCAAkC;EAClC,iCAAiC;EACjC,2BAA2B,EAAE,0DAA0D;AACzF;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,uDAAuD;AACzD;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,+DAA+D;AACjE;;AAEA,0CAA0C;AAC1C;EACE,oCAAoC;EACpC,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;EACf;;8BAE4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;EACE,oBAAoB;AACtB","sourcesContent":["/* [EXPERT_ANALYSIS]: Estilos para la nueva pantalla de Login minimalista */\n.login-page-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f5f5f5; /* Gris muy claro como en la imagen */\n  margin: 0;\n  padding: 0;\n}\n\n.login-card {\n  width: 100%;\n  max-width: 450px;\n  padding: 2rem;\n  text-align: center;\n}\n\n.login-card h2 {\n  font-family: \"Inter\", \"Segoe UI\", Roboto, sans-serif;\n  font-weight: 700;\n  font-size: 2.2rem;\n  color: #000;\n  margin-bottom: 2rem;\n}\n\n.login-form-minimal {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n  background-color: transparent !important; /* [EXPERT] Anula el blanco de App.css */\n  box-shadow: none !important;\n  max-width: none !important;\n  padding: 0 !important;\n}\n\n/* Estilo para los inputs */\n.login-input-minimal {\n  width: 100% !important;\n  padding: 0.8rem 1rem !important; /* [EXPERT] Altura reducida */\n  border: 1px solid #ccc !important;\n  border-radius: 10px !important;\n  font-size: 1.1rem !important;\n  transition: border-color 0.3s ease;\n  background-color: #fff !important;\n  margin-bottom: 0 !important; /* [EXPERT] Elimina margen de App.css que movía el icono */\n}\n\n.login-input-minimal:focus {\n  border-color: #007bff !important;\n  outline: none !important;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1) !important;\n}\n\n/* Contenedor del password */\n.password-wrapper {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.toggle-password-minimal {\n  position: absolute;\n  right: 15px;\n  cursor: pointer;\n  color: #666;\n  font-size: 1.1rem;\n  z-index: 10;\n  /* El icono se centra automáticamente gracias al wrapper flex */\n}\n\n/* Botón de Login (Estilo cuadrado azul) */\n.btn-login-minimal {\n  background-color: #007bff !important;\n  border: none !important;\n  border-radius: 12px !important;\n  width: 75px !important;\n  height: 75px !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  margin: 2rem auto 0 !important;\n  cursor: pointer;\n  transition:\n    transform 0.2s ease,\n    background-color 0.2s ease;\n}\n\n.btn-login-minimal:hover {\n  background-color: #0056b3 !important;\n  transform: scale(1.05);\n}\n\n.btn-login-minimal:active {\n  transform: scale(0.95);\n}\n\n.btn-login-minimal i {\n  font-size: 2.5rem !important;\n  color: #fff !important;\n}\n\n/* Estilos de PrimeReact Overrides si es necesario */\n.p-toast {\n  font-family: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
